import { __ } from '@wordpress/i18n';
import {
	InspectorControls,
	useBlockEditContext,
} from '@wordpress/block-editor';
import {
	PanelBody,
	PanelRow,
	BaseControl,
	ButtonGroup,
	Button,
	Dashicon,
	TextControl,
	ToggleControl,
	RangeControl,
	TabPanel,
	PanelTabs,
	Icon,
	Placeholder,
} from '@wordpress/components';
import { more } from '@wordpress/icons';
import InspectorIconSelector from '../inspector-components/inspector-icon-selector';
import InspectorImageSelector from '../inspector-components/inspector-image-selector';
import InspectorPresetsSelector from '../inspector-components/inspector-presets-selector';
import InspectorPanelBodyTabs from '../inspector-components/inspector-panel-body-tabs';
import InspectorResponsiveRangeControl from '../inspector-components/inspector-responsive-range-control';
import InspectorColorSelect from '../inspector-components/inspector-color-select';
import InspectorBorderStyle from '../inspector-components/inspector-border-style';
import InspectorBorder from '../inspector-components/inspector-border';
import InspectorFourDimension from '../inspector-components/inspector-four-dimension';
import InspectorTypographyControl from '../inspector-components/inspector-typography-control';
import InspectorSelectRow from '../inspector-components/inspector-select-row';
import InspectorIconImageControl from '../inspector-components/inspector-icon-image-control';
import InspectorSelectButton from '../inspector-components/inspector-select-button';
import InspectorSelectBlockVariation from '../inspector-components/inspector-select-block-variation';
import InspectorBorderBox from '../inspector-components/inspector-border-box';
import InspectorTypographyControlTab from '../inspector-components/inspector-typography-control-tab';
import InspectorCheckbox from '../inspector-components/inspector-checkbox';
import { capitalize, toCamelCase } from './index.js';
import InspectorShadow from '../inspector-components/inspector-shadow';
import InspectorBackgroundControlTab from '../inspector-components/inspector-background-control-tab';
import InspectorTextControl from '../inspector-components/inspector-text-control';
import InspectorSelectButtonResponsive from '../inspector-components/inspector-select-button-responsive';
import InspectorSelectRowResponsive from '../inspector-components/inspector-select-row-responsive';
// import blockJson from '../image/block.json';
const components = {
	InspectorIconSelector,
	InspectorImageSelector,
	InspectorPresetsSelector,
	InspectorPanelBodyTabs,
	InspectorResponsiveRangeControl,
	InspectorColorSelect,
	InspectorBorderStyle,
	InspectorBorder,
	InspectorFourDimension,
	InspectorTypographyControl,
	InspectorSelectRow,
	InspectorSelectRowResponsive,
	InspectorIconImageControl,
	InspectorSelectButton,
	InspectorSelectButtonResponsive,
	InspectorSelectBlockVariation,
	InspectorBorderBox,
	InspectorTypographyControlTab,
	InspectorCheckbox,
	InspectorShadow,
	InspectorBackgroundControlTab,
	InspectorTextControl,
};

function isInitialOpen( attributes, AccordionTitle ) {
	// console.log("attributes, AccordionTitle", attributes, AccordionTitle);
	if (
		attributes.hasOwnProperty( 'initialOpen' ) &&
		Array.isArray( attributes.initialOpen ) &&
		attributes.initialOpen.includes( AccordionTitle )
	) {
		return true;
	}
	if (
		attributes.hasOwnProperty( 'initialOpen' ) &&
		attributes.initialOpen.hasOwnProperty( 'accordionTab' ) &&
		AccordionTitle?.toLowerCase() ==
			attributes.initialOpen.accordionTab?.toLowerCase()
	) {
		return true;
	}
	return false;
}

export default function InspectorGeneratorAccordion( {
	AccordionTitle = 'general',
	initialOpen = false,
	attributes,
	setAttributes,
	defaultAttributes,
	inspectors = [],
	addNewInspector=false,
	handleDelete=false,
} ) {
	let enableKey = `${ toCamelCase( 'enable' + ' '.AccordionTitle ) }`;
	let showEnable = attributes.hasOwnProperty( enableKey );
	let currentShowEnable = attributes?.[ enableKey ];
	let showOtherInspector = showEnable ? currentShowEnable : true;

	return (
		<PanelBody
			title={ capitalize( AccordionTitle ) }
			className="!rounded-none !bg-transparent"
			initialOpen={ isInitialOpen( attributes, AccordionTitle ) }
			onToggle={ ( isOpen ) => {
				// Only set when panel is opened
				if ( isOpen ) {
					setAttributes( prevAttributes => ({
						...prevAttributes,
						initialOpen: {
							...( prevAttributes?.initialOpen || {} ),
							accordionTab: AccordionTitle,
						},
					} ));
				}
			} }
		>
			<div className="min-h-10 py-3 *:my-5">
				{ showEnable && (
					<BaseControl>
						<ToggleControl
							label={ __( 'Enable Sub Heading', 'alpha' ) }
							checked={ currentShowEnable === true }
							onChange={ ( val ) =>
								setAttributes( prevAttributes => ({ ...prevAttributes, [ enableKey ]: val } ))
							}
							__nextHasNoMarginBottom={ true }
						/>
					</BaseControl>
				) }

				{ showOtherInspector === true &&
					inspectors.map( ( inspector, index ) => {
						let {
							inspectorComponent = '',
							inspectorLabel = '',
							attributeKey = '',
							defaultAttributes = {},
							options = [],
							iconButton = false,
							dependsOn,
							dependsValue,
							availableUnits,
							availableMedia,
							max,
							min,
							colorOnly,
							conditionalRender,
							isResetButtonNeeded,
						} = inspector;
						const Component = components[ inspectorComponent ];

						let isRenderNeed = true;
						if ( dependsOn ) {
							let currentDependsOnValue =
								attributes?.[ dependsOn ];
							if ( dependsValue != currentDependsOnValue ) {
								isRenderNeed = false;
							}
						}
						if ( conditionalRender ) {
							const { attribute, value } = conditionalRender;
							if ( attributes[attribute] !== value ) {
								isRenderNeed = false;
							}
						}

						const isCustom = attributeKey.startsWith('custom_');

						if ( typeof Component === 'function' && isRenderNeed ) {
							return (
								<Component
									label={ inspectorLabel }
									value={ attributes?.[ attributeKey ] }
									defaultAttributes={ defaultAttributes }
									onChange={ ( val ) =>
										setAttributes( prevAttributes => ({ ...prevAttributes, [ attributeKey ]: val } ))
									}
									key={ index }
									options={ options }
									iconButton={ iconButton }
									availableMedia={ availableMedia }
									availableUnits={ availableUnits }
									max={ max }
									min={ min }
									colorOnly={ colorOnly }
									handleDelete={ attributeKey.startsWith('custom_') ? () => handleDelete(attributeKey) : undefined }
									isResetButtonNeeded={ isResetButtonNeeded }
								/>
							);
						}
					} ) }
					{addNewInspector && <Button isSecondary className="" onClick={addNewInspector}>Add Custom</Button>}
			</div>
		</PanelBody>
	);
}
